const state = {
  files_where_changed_by_ws: false,
  file_list: [],
  files_selected_left: [],
  files_selected_right: [],
  files_uploading: []
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/file/file.state.js
// module id = null
// module chunks = 